import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

import { RegisterForm } from '../register.interface'

export const RegisterValidationSchema = () => {
  const { t } = useTranslation()

  return yup.object<RegisterForm>({
    fio: yup.string().required(t('auth.register.errors.fio')),
    email: yup.string().email(t('emailErrors.invalidEmail')).required(t('emailErrors.emailRequired')),
    password: yup.string().min(8, t('auth.register.errors.passwordLength')).required(t('auth.register.errors.passwordRequired')),
    passwordConfirm: yup
      .string()
      .oneOf([yup.ref('password')], t('auth.register.errors.passwordMismatch'))
      .required(t('auth.register.errors.passwordConfirm')),
    companyName: yup.string().required(t('auth.register.errors.companyRequired')),
    companyInn: yup.string().required(t('auth.register.errors.companyInnRequired')),
    companyOgrn: yup.string().required(t('auth.register.errors.companyOgrnRequired')),
  })
}
